import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { SlashCommand, CopilotPlaybooksService } from '../../services/copilot-playbooks.service';

@Component({
  selector: 'lib-copilot-slash-menu',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './copilot-slash-menu.component.html',
  styleUrl: './copilot-slash-menu.component.scss',
  host: {
    '(keydown.escape)': 'onEscape()',
  },
})
export class CopilotSlashMenuComponent {
  private readonly playbooksService = inject(CopilotPlaybooksService);

  visible = input<boolean>(false);
  query = input<string>('');

  commandSelected = output<SlashCommand>();
  closed = output<void>();

  readonly activeIndex = signal(0);

  readonly filteredCommands = computed(() =>
    this.playbooksService.getFilteredSlashCommands(this.query())
  );

  selectCommand(cmd: SlashCommand): void {
    this.commandSelected.emit(cmd);
  }

  onEscape(): void {
    this.closed.emit();
  }

  onKeydown(event: KeyboardEvent): void {
    const cmds = this.filteredCommands();
    if (!cmds.length) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.activeIndex.update((i) => Math.min(i + 1, cmds.length - 1));
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.activeIndex.update((i) => Math.max(i - 1, 0));
    } else if (event.key === 'Enter') {
      event.preventDefault();
      const cmd = cmds[this.activeIndex()];
      if (cmd) this.selectCommand(cmd);
    } else if (event.key === 'Escape') {
      this.closed.emit();
    }
  }
}
